import React, { useState } from 'react';
import { CampaignByIdLeadCardProps } from './campaignModels';
import {
  LeadCardAvatarIcon,
  LeadsChevronDownIcon,
  RemoveIcon,
} from '../../../assets';
import { getRelativeTime } from '../../../helpers/dateHelpers';
import { useParams } from 'react-router-dom';
import RemoveLeadButton from '../../leads/components/RemoveLeadButton';

const CampaignByIdLeadCard: React.FC<CampaignByIdLeadCardProps> = ({
  lead,
  refetchLeads,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { campaignId } = useParams();
  const handleTriggerExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="campaign-by-id__leads-card-container">
      <div
        className="campaign-by-id__leads-card-row"
        onClick={handleTriggerExpand}
      >
        <div className="campaign-by-id__leads-card-row-start">
          <div className="campaign-by-id__leads-card-icon">
            <LeadCardAvatarIcon />
          </div>
          <div className="campaign-by-id__leads-card-row-start-content">
            <span className="campaign-by-id__lead-name">
              {lead?.firstname} {lead?.lastname}
            </span>
            <span className="campaign-by-id__lead-email">{lead?.email}</span>
            <span className="campaign-by-id__lead-added">
              {lead?.createdAt ? getRelativeTime(lead.createdAt) : ''}
            </span>
          </div>
        </div>
        <div className="campaign-by-id__leads-card-row-end">
          <button
            className="campaign-by-id__leads-remove-button"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <RemoveLeadButton
              leadId={lead.id}
              refetchLeads={refetchLeads}
              campaignId={campaignId ?? ''}
            />
          </button>
          <div
            className={`${isExpanded ? 'rotated' : ''} campaign-by-id__leads-expand-button`}
          >
            <LeadsChevronDownIcon />
          </div>
        </div>
      </div>
      {isExpanded && (
        <div className="campaign-by-id__leads-card-additional">
          <div className="campaign-by-id__leads-card-additional-container">
            <span className="campaign-by-id__leads-card-additional-title">
              Company name
            </span>
            <span className="campaign-by-id__leads-card-additional-value">
              {lead?.company}
            </span>
          </div>
          <div className="campaign-by-id__leads-card-additional-container">
            <span className="campaign-by-id__leads-card-additional-title">
              Full name
            </span>
            <span className="campaign-by-id__leads-card-additional-value">
              {lead?.firstname} {lead?.lastname}
            </span>
          </div>
          <div className="campaign-by-id__leads-card-additional-container">
            <span className="campaign-by-id__leads-card-additional-title">
              Email
            </span>
            <span className="campaign-by-id__leads-card-additional-value">
              {lead?.email ?? 'N/A'}
            </span>
          </div>
          <div className="campaign-by-id__leads-card-additional-container">
            <span className="campaign-by-id__leads-card-additional-title">
              Phone
            </span>
            <span className="campaign-by-id__leads-card-additional-value">
              {lead?.phone ?? 'N/A'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignByIdLeadCard;
